const config = {
  // baseURL: "https://fakestoreapi.com/",
  baseURL: "https://fakestoreapi.herokuapp.com/",
  timeout: 100000,
};

export default config;
